import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEn from "./languages/en.json";
import translationGuj from "./languages/gu.json";
import translationHin from "./languages/hi.json";

const resources = {
  en: { translation: translationEn },
  gu: { translation: translationGuj },
  hi: { translation: translationHin },
};

const defaultLanguage = localStorage.getItem("i18n") || "en";

i18n.use(initReactI18next).init({
  resources: resources,
  lng: defaultLanguage, // default language
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // React already protects from XSS
  },
});

export default i18n;